const regexp = /^\d+$/;
module.exports = (v) => regexp.test(v);
